import { useState } from 'react'
import { createForm } from '../../../../../utils/newforms/createForm'
import getFieldRenderObject from '../../../../../utils/newforms/render/getFieldRenderObject'
import StatusMessage, { useStatusMessage } from '../../../../../ui/StatusMessage/StatusMessage'
import isFormValid from '../../../../../utils/newforms/validation/isFormValid'
import PopUp from '../../../../../ui/PopUp/PopUp'
import Button from '../../../../../ui/Button/Button'
import FormRender from '../../../../../utils/newforms/render/FormRender'
import getFormValues from '../../../../../utils/newforms/getFormValues'
import addDoc from '../../../../../utils/db/addDoc'
import getCollection from '../../../../../utils/db/getCollection'
import { updateDoc } from '../../../../../utils/db/updateDoc'
import './AddBanner.sass'

function AddBanner({ categoryId, subcategoryId, onClose }) {
  const [form, setForm] = useState(createForm({ formPattern: new BannerForm() }))
  const [showErrors] = useState(false)
  const [statusMessage, setStatusMessage] = useStatusMessage()
  const [isLoading, setIsLoading] = useState(false)

  const onSubmit = async () => {
    if (!isFormValid({ form })) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      return setStatusMessage({
        show: true,
        type: 'fail',
        message: 'Будь ласка, заповніть усі поля форми',
        closeAfter: 5000,
      })
    }

    setIsLoading(true)
    const data = getFormValues({ form })

    try {
      const existing = await getCollection({ path: 'settings/banners/list', docIdName: 'id' })
      const bumpResults = await Promise.all(
        existing.map((banner) =>
          updateDoc({
            path: 'settings/banners/list',
            docId: banner.id,
            data: { pos: (Number(banner.pos) || 0) + 1 },
          })
        )
      )

      if (bumpResults.some((result) => result === 'fail')) {
        throw new Error('Failed to shift banner positions')
      }

      await addDoc({ path: 'settings/banners/list', data: { ...data, pos: 0 } })
      onClose()
    } catch (err) {
      console.error(err)
      setIsLoading(false)
      setStatusMessage({
        show: true,
        type: 'fail',
        message: 'Не вдалося зберегти банер. Спробуйте ще раз.',
        closeAfter: 5000,
      })
    }
  }

  return (
    <PopUp
      title={'Додати серію банерів'}
      customButtons={[
        <Button isLoading={isLoading} onClick={onSubmit} title="Зберегти" theme="solid" fill="accent" />,
        <Button onClick={onClose} title="Закрити" theme="bounded" border="gray" color="gray" />,
      ]}
      show
      close={onClose}
      className="AddBanner"
    >
      <div className="AddBanner-Content">
        {statusMessage.show && (
          <StatusMessage className="Site-StatusMessage" type={statusMessage.type} message={statusMessage.message} />
        )}
        <FormRender
          sections={[
            {
              fields: ['name'],
            },
          ]}
          form={form}
          setForm={setForm}
          errors={showErrors}
        />
      </div>
    </PopUp>
  )
}

class BannerForm {
  constructor() {
    this.name = {
      field: {
        fieldId: 'name',
        fieldType: 'input',
        inputType: 'text',
        label: 'Назва серії',
        required: true,
      },
      render: getFieldRenderObject(),
    }
    this.isActive = {
      field: {
        fieldId: 'isActive',
        fieldType: 'checkbox',
        label: 'Задіяти на сайті',
        value: false,
      },
      render: getFieldRenderObject(),
    }
    this.pos = {
      field: { fieldId: 'pos', value: 0 },
      render: getFieldRenderObject({ isSystem: true }),
    }
  }
}

export default AddBanner
